import React from 'react';
import clsx from 'clsx';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { CheckOutStateContext } from '../../../providers/CheckOutStateContextProvider';
import { Skin } from '../../../models/common/Skin';
import themePrimary from '../../../styles/themePrimary';

const useStyles = makeStyles({
  button: {
    backgroundColor: props => (props as Skin).primary_main_color + ' !important',
  },
  buttonAlternate: {
    backgroundColor: themePrimary.palette.primary.contrastText + '!important',
    border: props => '3px solid ' + (props as Skin).primary_main_color,
    color: props => (props as Skin).primary_main_color + ' !important',
  },
});

const SmallButtonInternal = withStyles((themePrimary) => ({
  root: {
    color: themePrimary.palette.primary.contrastText,
    boxShadow: 'none',
    fontSize: themePrimary.typography.h6.fontSize,
    width: '100%',
    height: '60px',
    borderRadius: '60px',
    lineHeight: '1.4em',
  },
}))(Button);

export type SmallButtonClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface SmallButtonProps {
    label: string,
    disabled: boolean,
    alternateColor: boolean,
    onClickHandler: SmallButtonClickHandler
}

export default function SmallButton(props: SmallButtonProps) {
    const { label, disabled, alternateColor, onClickHandler } = props;
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

  return (
    <div>
        <SmallButtonInternal 
            className={clsx({[classes.buttonAlternate]: alternateColor, [classes.button]: !alternateColor})}
            variant="contained" 
            disabled={disabled}
            onClick={onClickHandler}>
            {label}
        </SmallButtonInternal>
    </div>
  );
}